import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Summer/Time/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Time',
  field: 'Measurement',
  weeks: [4, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/1OClockAndHalfPast" */ './1OClockAndHalfPast'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/2QuarterPastAndQuarterTo" */ './2QuarterPastAndQuarterTo'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/3TellTimePastTheHour" */ './3TellTimePastTheHour'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/4TellTimeTimeToTheHour" */ './4TellTimeTimeToTheHour'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Time/5TellTheTimeTo5MinutesY2" */ './5TellTheTimeTo5MinutesY2'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Time/6MinutesInAnHour" */ './6MinutesInAnHour')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Time/7HoursInADay" */ './7HoursInADay')
    })
  ]
});
export default Block;
